import { s, t } from '../../val.config';

const commons = {
  size: s
    .union(
      s.literal('xs'),
      s.literal('sm'),
      s.literal('md'),
      s.literal('lg'),
      s.literal('xl')
    )
    .nullable(),
};

const commonsImages = {
  clickable: s.boolean().nullable(),
};

const keepAspectRatio = {
  keepAspectRatio: s.boolean().nullable(),
};

const listItem = s.object({
  text: s.string(),
  // href: s.string().nullable(),
});

export const linkListsElementSchema = s.object({
  type: s.literal('linkListsElement'),
  lists: s.array(
    s.object({
      title: s.string(),
      items: s.array(listItem),
    })
  ),
});

export const singleImageElementSchema = s.object({
  type: s.literal('singleImageElement'),
  image: s.image(),
  ...keepAspectRatio,
  ...commonsImages,
});

export const doubleImageElementSchema = s.object({
  type: s.literal('doubleImageElement'),
  image1: s.image(),
  image2: s.image(),
  ...commons,
  ...commonsImages,
});

export const doubleImageElementNewSchema = s.object({
  type: s.literal('doubleImageElementNew'),
  image1: s.image(),
  image2: s.image(),
  text: s.string().nullable(),
  centered: s.boolean(),
  layout: s.union(s.literal('square-tall'), s.literal('tall-square')),
});

export const textElementSchema = s.object({
  type: s.literal('textElement'),
  title: s.string().nullable(),
  text: s.richtext({
    style: {
      bold: true,
      italic: true,
      lineThrough: true,
    },
    block: {
      h1: false,
      h2: false,
      h3: false,
      h4: true,
      h5: true,
      h6: true,
      ul: true,
      ol: true,
    },
    inline: {
      a: true,
      img: true,
    },
  }),
});

export const textAndImageElementSchema = s.object({
  type: s.literal('textAndImageElement'),
  title: s.string().nullable(),
  text: s.richtext({
    style: {
      bold: true,
      italic: true,
      lineThrough: true,
    },
    block: {
      h1: true,
      h2: true,
      h3: true,
      h4: true,
      h5: true,
      h6: true,
      ul: true,
      ol: true,
    },
    inline: {
      a: true,
      img: true,
    },
  }),
  image: s.image(),
  ...commonsImages,
  side: s.boolean().nullable(),
  ...commons,
});

export const projectQuoteElementSchema = s.object({
  type: s.literal('projectQuoteElement'),
  quote: s.string(),
  author: s.string().nullable(),
});

export const multipleImageElementSchema = s.object({
  type: s.literal('multipleImageElement'),
  images: s.array(s.image()),
});

export const videoElementSchema = s.object({
  type: s.literal('videoElement'),
  video: s.file(),
});

export const linksElementSchema = s.object({
  type: s.literal('linksElement'),
  links: s.array(
    s.object({
      text: s.string(),
      href: s.string().raw(),
    })
  ),
});

export const imageCarouselElement = s.object({
  type: s.literal('imageCarouselElement'),
  images: s.array(s.image()),
});

export type SingleImageElementSchema = t.inferSchema<
  typeof singleImageElementSchema
>;
export type DoubleImageElementSchema = t.inferSchema<
  typeof doubleImageElementSchema
>;

export type DoubleImageElementNewSchema = t.inferSchema<
  typeof doubleImageElementNewSchema
>;
export type TextElementSchema = t.inferSchema<typeof textElementSchema>;

export type TextAndImageElementSchema = t.inferSchema<
  typeof textAndImageElementSchema
>;

export type ProjectQuoteElementSchema = t.inferSchema<
  typeof projectQuoteElementSchema
>;

export type MultipleImageElementSchema = t.inferSchema<
  typeof multipleImageElementSchema
>;

export type VideoElementSchema = t.inferSchema<typeof videoElementSchema>;

export type LinksElementSchema = t.inferSchema<typeof linksElementSchema>;

export type LinkListsElementSchema = t.inferSchema<
  typeof linkListsElementSchema
>;

export type ImageCarouselElementSchema = t.inferSchema<
  typeof imageCarouselElement
>;

export type PageElement =
  | SingleImageElementSchema
  | DoubleImageElementSchema
  | DoubleImageElementNewSchema
  | TextElementSchema
  | TextAndImageElementSchema
  | ProjectQuoteElementSchema
  | MultipleImageElementSchema
  | LinksElementSchema
  | LinkListsElementSchema
  | ImageCarouselElementSchema
  | VideoElementSchema;
